module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingIdrott.fdc19854.png";